webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fab: false,
      drawer: false,
      links: [{ link: '/', title: 'Home' }, { link: 'wedding', title: 'Wedding' }, { link: 'birthday', title: 'Birthday' }, { link: 'cupcakes', title: 'Cupcakes' }, { link: 'other', title: 'Other Occasions' }, { link: 'contact', title: 'Contact' }]
    };
  },

  name: 'App'
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fab: false,
      count: 0
    };
  },

  methods: {
    scrollPage: function scrollPage() {
      window.scrollTo({
        top: 500,
        behavior: 'smooth'
      });
    },
    secretButton: function secretButton() {
      this.count++;
      if (this.count === 10) {
        this.$router.push('/edit');
      }
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      gallery: false,
      activeImage: -1,
      images: []
    };
  },
  mounted: function mounted() {
    var images = [];
    __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('images').orderByChild('type').equalTo('wedding').once('value').then(function (snap) {
      for (var image in snap.val()) {
        images.push(snap.val()[image]);
      }
    });
    this.images = images;
  },

  methods: {
    enlargeImage: function enlargeImage(n) {
      this.activeImage = n;
      this.gallery = true;
    },
    setGalleryState: function setGalleryState(val) {
      this.gallery = val;
    }
  }
});

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      gallery: false,
      activeImage: -1,
      images: []
    };
  },
  mounted: function mounted() {
    var images = [];
    __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('images').orderByChild('type').equalTo('birthday').once('value').then(function (snap) {
      for (var image in snap.val()) {
        images.push(snap.val()[image]);
      }
    });
    this.images = images;
  },

  methods: {
    enlargeImage: function enlargeImage(n) {
      this.activeImage = n;
      this.gallery = true;
    },
    setGalleryState: function setGalleryState(val) {
      this.gallery = val;
    }
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      gallery: false,
      activeImage: -1,
      images: []
    };
  },
  mounted: function mounted() {
    var images = [];
    __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('images').orderByChild('type').equalTo('cupcakes').once('value').then(function (snap) {
      for (var image in snap.val()) {
        images.push(snap.val()[image]);
      }
    });
    this.images = images;
  },

  methods: {
    enlargeImage: function enlargeImage(n) {
      this.activeImage = n;
      this.gallery = true;
    },
    setGalleryState: function setGalleryState(val) {
      this.gallery = val;
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      gallery: false,
      activeImage: -1,
      images: []
    };
  },
  mounted: function mounted() {
    var images = [];
    __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('images').orderByChild('type').equalTo('other').once('value').then(function (snap) {
      for (var image in snap.val()) {
        images.push(snap.val()[image]);
      }
    });
    this.images = images;
  },

  methods: {
    enlargeImage: function enlargeImage(n) {
      this.activeImage = n;
      this.gallery = true;
    },
    setGalleryState: function setGalleryState(val) {
      this.gallery = val;
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_database__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_storage__ = __webpack_require__(48);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      gallery: false,
      activeImage: -1,
      images: [],
      mode: 'view',
      imageName: '',
      imageType: 'wedding',
      imageCost: '',
      activeKey: '',
      loading: false
    };
  },
  mounted: function mounted() {
    this.getImages();
  },

  methods: {
    getImages: function getImages() {
      var images = [];
      __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('images').once('value').then(function (snap) {
        for (var image in snap.val()) {
          var imageObj = snap.val()[image];
          imageObj.key = image;
          images.push(imageObj);
        }
      });
      this.images = images;
    },
    setEditImage: function setEditImage(image) {
      this.mode = 'update';
      this.activeKey = image.key;
      this.imageType = image.type;
      this.imageName = image.name;
      this.imageCost = image.cost;
    },
    resetApp: function resetApp() {
      this.loading = false;
      this.getImages();
      this.mode = 'view';
    },
    sendData: function sendData() {
      var _this = this;

      if (this.loading === false) {
        this.loading = true;
        if (this.mode === 'add') {
          var file = document.getElementById('file-input').files[0];
          var timestamp = Date.now();
          __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.storage().ref('images/' + timestamp + '.jpg').put(file).then(function () {
            __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.storage().ref('images/' + timestamp + '.jpg').getDownloadURL().then(function (URL) {
              __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('images').push({
                type: _this.imageType,
                name: _this.imageName,
                cost: _this.imageCost,
                src: URL
              }).then(function () {
                _this.resetApp();
              });
            });
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('images').child(this.activeKey).update({
            type: this.imageType,
            name: this.imageName,
            cost: this.imageCost
          }).then(function () {
            _this.resetApp();
          });
        }
      }
    },
    deleteData: function deleteData() {
      var _this2 = this;

      if (this.loading === false) {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.database().ref('images').child(this.activeKey).remove().then(function () {
          _this2.resetApp();
        });
      }
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(52);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: '',
      password: ''
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth().signInWithEmailAndPassword(this.user, this.password).then(function () {
        _this.$router.push('/Edit');
      });
    }
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['show', 'images', 'index'],
  data: function data() {
    return {
      showDialog: false,
      activeIndex: -1
    };
  },

  watch: {
    show: function show(val) {
      this.showDialog = val;
    },
    index: function index(val) {
      this.activeIndex = val;
    },
    showDialog: function showDialog(val) {
      this.$emit('visible', val);
    }
  },
  computed: {
    activeImage: function activeImage() {
      return this.images[this.activeIndex];
    }
  },
  methods: {
    nextImage: function nextImage() {
      if (this.images[this.activeIndex + 1] !== undefined) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
    },
    lastImage: function lastImage() {
      if (this.images[this.activeIndex - 1] !== undefined) {
        this.activeIndex--;
      } else {
        this.activeIndex = this.images.length - 1;
      }
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_css__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Gallery_vue__ = __webpack_require__(57);









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuetify___default.a, {
  theme: {
    primary: '#B388FF',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('gallery', __WEBPACK_IMPORTED_MODULE_7__components_Gallery_vue__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  data: function data() {
    return {
      userDetails: {}
    };
  },
  created: function created() {
    var config = {
      apiKey: 'AIzaSyA0CGgFJMNmKXsiDzLsLFU_-B6Fa6DyJzo',
      authDomain: 'cakesbykarenrichardson.firebaseapp.com',
      databaseURL: 'https://cakesbykarenrichardson.firebaseio.com',
      projectId: 'cakesbykarenrichardson',
      storageBucket: 'cakesbykarenrichardson.appspot.com'
    };
    __WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.initializeApp(config);
    localStorage.removeItem('user');
    __WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.auth().onAuthStateChanged(function (user) {
      if (user) {
        localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
      }
    });
  },

  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]);
  }
});

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a76e09ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(27);
function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a76e09ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-navigation-drawer',{attrs:{"temporary":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',_vm._l((_vm.links),function(link){return _c('v-list-tile',{key:link.title,attrs:{"to":link.link}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(link.title))])],1)],1)}))],1),_vm._v(" "),_c('v-toolbar',{staticClass:"white",attrs:{"app":""}},[_c('v-toolbar-side-icon',{staticClass:"hidden-md-and-up",on:{"click":function($event){_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',{staticStyle:{"font-family":"'Pacifico', cursive","overflow":"visible"}},[_vm._v("Cakes by Karen Richardson")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-sm-and-down"},_vm._l((_vm.links),function(link){return _c('v-btn',{key:link.title,attrs:{"flat":"","to":link.link,"exact":"","router":""}},[_vm._v(_vm._s(link.title))])}))],1),_vm._v(" "),_c('v-content',{attrs:{"app":""}},[_c('router-view')],1),_vm._v(" "),_c('v-speed-dial',{attrs:{"bottom":"","right":"","fixed":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":"","fab":""},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("more_horiz")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"blue darken-4","href":"https://facebook.com/cakesbykarenrichardsonuk"}},[_c('v-icon',[_vm._v("fab fa-facebook-f")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"red","href":"https://www.instagram.com/cakesbykarenrichardson/"}},[_c('v-icon',[_vm._v("fab fa-instagram")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"indigo","href":"mailto:karen@cakesbykarenrichardson.co.uk"}},[_c('v-icon',[_vm._v("email")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","dark":"","small":"","color":"green","href":"tel:07985790947"}},[_c('v-icon',[_vm._v("phone")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Wedding__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Birthday__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Cupcakes__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Other__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Contact__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Edit__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Login__ = __webpack_require__(51);











__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/wedding',
    name: 'Wedding',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Wedding__["a" /* default */]
  }, {
    path: '/birthday',
    name: 'Birthday',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Birthday__["a" /* default */]
  }, {
    path: '/other',
    name: 'Other',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Other__["a" /* default */]
  }, {
    path: '/cupcakes',
    name: 'Cupcakes',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Cupcakes__["a" /* default */]
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_7__components_Contact__["a" /* default */]
  }, {
    path: '/edit',
    name: 'Edit',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Edit__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      localStorage.getItem('user') === null ? next('/login') : next();
    }
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_9__components_Login__["a" /* default */],
    beforeEnter: function beforeEnter(to, from, next) {
      localStorage.getItem('user') !== null ? next('/edit') : next();
    }
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
}));

/***/ }),
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00237c6d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(32);
function injectStyle (ssrContext) {
  __webpack_require__(31)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-00237c6d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00237c6d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',[_c('v-parallax',{attrs:{"src":"static/img/background.jpg","height":"500"}},[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('h1',{staticClass:"black--text mb-2 display-1 text-xs-center"},[_vm._v("Cakes by")]),_vm._v(" "),_c('h1',{staticClass:"black--text mb-4 display-2 text-xs-center",on:{"click":_vm.secretButton}},[_vm._v("Karen Richardson")]),_vm._v(" "),_c('p',{staticClass:"black--text mb-2 title text-xs-center font-weight-light"},[_vm._v("Supplying a wide range of cakes in the Birmingham, Solihull and Tamworth areas.")]),_vm._v(" "),_c('v-btn',{staticClass:"primary mt-5",attrs:{"dark":"","fab":""},on:{"click":_vm.scrollPage}},[_c('v-icon',[_vm._v("expand_more")])],1)],1)],1)],1),_vm._v(" "),_c('section',{attrs:{"id":"scroll-target"}},[_c('v-layout',{staticClass:"my-5",attrs:{"column":"","wrap":"","align-center":""}},[_c('v-flex',{staticClass:"my-3",attrs:{"xs12":"","sm4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('h2',{staticClass:"headline"},[_vm._v("Hi, I'm Karen Richardson")]),_vm._v(" "),_c('span',{staticClass:"subheading"})])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-start":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('img',{staticStyle:{"height":"150px","width":"150px","border-radius":"50%"},attrs:{"src":"static/img/wedding.jpg"}})]),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline text-xs-center"},[_vm._v("Wedding Cakes")])]),_vm._v(" "),_c('v-card-actions',{staticClass:"layout justify-center"},[_c('v-btn',{staticClass:"primary primary--text",attrs:{"outline":"","to":"/wedding"}},[_vm._v("View Images")])],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n                      Beautiful wedding cakes made to your own design.\n                    ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('img',{staticStyle:{"height":"150px","width":"150px","border-radius":"50%"},attrs:{"src":"static/img/birthday.jpg"}})]),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Birthday Cakes")])]),_vm._v(" "),_c('v-card-actions',{staticClass:"layout justify-center"},[_c('v-btn',{staticClass:"primary primary--text",attrs:{"outline":"","to":"/birthday"}},[_vm._v("View Images")])],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n                      I offer a wide variety of Birthday cake designs for your special occasion.  \n                    ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-card',{staticClass:"elevation-0 transparent"},[_c('v-card-text',{staticClass:"text-xs-center"},[_c('img',{staticStyle:{"height":"150px","width":"150px","border-radius":"50%"},attrs:{"src":"static/img/cupcakes.jpg"}})]),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline text-xs-center"},[_vm._v("Cup Cakes")])]),_vm._v(" "),_c('v-card-actions',{staticClass:"layout justify-center"},[_c('v-btn',{staticClass:"primary primary--text",attrs:{"outline":"","to":"/cupcakes"}},[_vm._v("View Images")])],1),_vm._v(" "),_c('v-card-text',[_vm._v("\n                      A wide variety of cupcakes are available to your choice. \n                    ")])],1)],1)],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wedding_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3897ca1b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wedding_vue__ = __webpack_require__(38);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wedding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3897ca1b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wedding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-title',{staticClass:"layout justify-center"},[_c('h1',[_vm._v("Wedding Cakes")])]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[_vm._v("\n        Beautiful wedding cakes made to your own design.\n      ")]),_vm._v(" "),(_vm.images.length > 0)?_c('v-container',{attrs:{"grid-list-sm":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.images),function(image,i){return _c('v-flex',{key:i,attrs:{"xs4":"","d-flex":""}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-card',{staticClass:"d-flex",class:("elevation-" + (hover ? 24 : 0)),style:({cursor: hover ? 'pointer' : 'default'}),attrs:{"flat":"","tile":""}},[_c('v-img',{staticClass:"grey lighten-2",attrs:{"src":image.src,"lazy-src":"https://picsum.photos/10/6?image=1","aspect-ratio":"0.9"},on:{"click":function($event){$event.stopPropagation();_vm.enlargeImage(i)}}},[_c('v-layout',{attrs:{"slot":"placeholder","fill-height":"","align-center":"","justify-center":"","ma-0":""},slot:"placeholder"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)],1)],1)}}])})],1)}))],1):_c('v-progress-linear',{attrs:{"indeterminate":true}})],1)],1),_vm._v(" "),_c('gallery',{attrs:{"show":_vm.gallery,"images":_vm.images,"index":_vm.activeImage},on:{"visible":_vm.setGalleryState}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Birthday_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_123301c5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Birthday_vue__ = __webpack_require__(40);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Birthday_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_123301c5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Birthday_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-title',{staticClass:"layout justify-center"},[_c('h1',[_vm._v("Birthday Cakes")])]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[_vm._v("\n        I offer a wide variety of Birthday cake designs for your special occasion.\n      ")]),_vm._v(" "),(_vm.images.length > 0)?_c('v-container',{attrs:{"grid-list-sm":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.images),function(image,i){return _c('v-flex',{key:i,attrs:{"xs4":"","d-flex":""}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-card',{staticClass:"d-flex",class:("elevation-" + (hover ? 24 : 0)),style:({cursor: hover ? 'pointer' : 'default'}),attrs:{"flat":"","tile":""}},[_c('v-img',{staticClass:"grey lighten-2",attrs:{"src":image.src,"lazy-src":"https://picsum.photos/10/6?image=1","aspect-ratio":"0.9"},on:{"click":function($event){$event.stopPropagation();_vm.enlargeImage(i)}}},[_c('v-layout',{attrs:{"slot":"placeholder","fill-height":"","align-center":"","justify-center":"","ma-0":""},slot:"placeholder"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)],1)],1)}}])})],1)}))],1):_c('v-progress-linear',{attrs:{"indeterminate":true}})],1)],1),_vm._v(" "),_c('gallery',{attrs:{"show":_vm.gallery,"images":_vm.images,"index":_vm.activeImage},on:{"visible":_vm.setGalleryState}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cupcakes_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_190333e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cupcakes_vue__ = __webpack_require__(42);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Cupcakes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_190333e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Cupcakes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-title',{staticClass:"layout justify-center"},[_c('h1',[_vm._v("Cupcakes")])]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[_vm._v("\n         A wide variety of cupcakes are available to your choice.\n      ")]),_vm._v(" "),(_vm.images.length > 0)?_c('v-container',{attrs:{"grid-list-sm":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.images),function(image,i){return _c('v-flex',{key:i,attrs:{"xs4":"","d-flex":""}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-card',{staticClass:"d-flex",class:("elevation-" + (hover ? 24 : 0)),style:({cursor: hover ? 'pointer' : 'default'}),attrs:{"flat":"","tile":""}},[_c('v-img',{staticClass:"grey lighten-2",attrs:{"src":image.src,"lazy-src":"https://picsum.photos/10/6?image=1","aspect-ratio":"0.9"},on:{"click":function($event){$event.stopPropagation();_vm.enlargeImage(i)}}},[_c('v-layout',{attrs:{"slot":"placeholder","fill-height":"","align-center":"","justify-center":"","ma-0":""},slot:"placeholder"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)],1)],1)}}])})],1)}))],1):_c('v-progress-linear',{attrs:{"indeterminate":true}})],1)],1),_vm._v(" "),_c('gallery',{attrs:{"show":_vm.gallery,"images":_vm.images,"index":_vm.activeImage},on:{"visible":_vm.setGalleryState}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Other_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60aea101_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Other_vue__ = __webpack_require__(44);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Other_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60aea101_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Other_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-title',{staticClass:"layout justify-center"},[_c('h1',[_vm._v("Other Occasions")])]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[_vm._v("\n        A special cake for your special occasion.\n      ")]),_vm._v(" "),(_vm.images.length > 0)?_c('v-container',{attrs:{"grid-list-sm":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.images),function(image,i){return _c('v-flex',{key:i,attrs:{"xs4":"","d-flex":""}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-card',{staticClass:"d-flex",class:("elevation-" + (hover ? 24 : 0)),style:({cursor: hover ? 'pointer' : 'default'}),attrs:{"flat":"","tile":""}},[_c('v-img',{staticClass:"grey lighten-2",attrs:{"src":image.src,"lazy-src":"https://picsum.photos/10/6?image=1","aspect-ratio":"0.9"},on:{"click":function($event){$event.stopPropagation();_vm.enlargeImage(i)}}},[_c('v-layout',{attrs:{"slot":"placeholder","fill-height":"","align-center":"","justify-center":"","ma-0":""},slot:"placeholder"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)],1)],1)}}])})],1)}))],1):_c('v-progress-linear',{attrs:{"indeterminate":true}})],1)],1),_vm._v(" "),_c('gallery',{attrs:{"show":_vm.gallery,"images":_vm.images,"index":_vm.activeImage},on:{"visible":_vm.setGalleryState}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d8ec50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__(46);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33d8ec50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-title',{staticClass:"layout justify-center"},[_c('h1',[_vm._v("Contact Me")])]),_vm._v(" "),_c('v-card-text',{staticClass:"text-xs-center"},[_vm._v("\n        I am able to serve the Birmingham, Solihull and Tamworth areas. You can contact me via any of the methods below and I would be delighted to discuss your cake ideas.\n      ")]),_vm._v(" "),_c('v-list',[_c('v-list-tile',{attrs:{"href":"tel:07985790647"}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("phone_android")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("0798 579 0947")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Mobile")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"href":"tel:01217068691"}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("0121 706 8691")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Work")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',{attrs:{"href":"mailto:karen@cakesbykarenrichardson.co.uk"}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("karen@cakesbykarenrichardson.co.uk")])],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}}),_vm._v(" "),_c('v-list-tile',{attrs:{"href":"https://facebook.com/cakesbykarenrichardsonuk"}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fab fa-facebook")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Facebook")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("facebook.com/cakesbykarenrichardsonuk")])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"href":"https://instagram.com/cakesbykarenrichardson"}},[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fab fa-instagram")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Instagram")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("instagram.com/cakesbykarenrichardson")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dfe41ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__(50);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dfe41ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticClass:"elevation-0"},[(_vm.mode=='view')?_c('v-btn',{staticClass:"mt-5 primary",attrs:{"fab":"","absolute":"","right":"","top":""},on:{"click":function($event){_vm.mode='add'}}},[_vm._v("Add")]):_vm._e(),_vm._v(" "),_c('v-card-title',{staticClass:"layout justify-center"},[_c('h1',[_vm._v("Edit Images")])]),_vm._v(" "),(_vm.images.length > 0 && _vm.mode==='view')?_c('v-container',{attrs:{"grid-list-sm":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.images),function(image){return _c('v-flex',{key:image.key,attrs:{"xs4":"","d-flex":""}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-card',{class:("elevation-" + (hover ? 24 : 2)),style:({cursor: hover ? 'pointer' : 'default'})},[_c('v-img',{staticClass:"grey lighten-2",attrs:{"src":image.src,"lazy-src":"https://picsum.photos/10/6?image=1","aspect-ratio":"0.7","max-height":"200px"}},[_c('v-layout',{attrs:{"slot":"placeholder","fill-height":"","align-center":"","justify-center":"","ma-0":""},slot:"placeholder"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('v-btn',{staticClass:"mt-4",staticStyle:{"left":"5px"},attrs:{"fab":"","absolute":"","top":"","left":"","small":""},on:{"click":function($event){_vm.setEditImage(image)}}},[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('div',[_vm._v("Name: "+_vm._s(image.name))]),_vm._v(" "),_c('div',[_vm._v("Cost: "+_vm._s(image.cost))])],1)])],1)}}])})],1)}))],1):_vm._e(),_vm._v(" "),_c('v-container',[(_vm.mode === 'add' || _vm.mode === 'update')?_c('v-form',[_c('v-select',{attrs:{"items":['wedding', 'birthday', 'cupcakes', 'other'],"label":"Type"},model:{value:(_vm.imageType),callback:function ($$v) {_vm.imageType=$$v},expression:"imageType"}}),_vm._v(" "),_c('v-text-field',{attrs:{"required":"","label":"Name"},model:{value:(_vm.imageName),callback:function ($$v) {_vm.imageName=$$v},expression:"imageName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"required":"","label":"Cost"},model:{value:(_vm.imageCost),callback:function ($$v) {_vm.imageCost=$$v},expression:"imageCost"}}),_vm._v(" "),(_vm.mode === 'add')?_c('input',{attrs:{"id":"file-input","type":"file"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.mode = 'view'}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.loading},on:{"click":_vm.sendData}},[_vm._v("Submit")]),_vm._v(" "),(_vm.mode != 'add')?_c('v-btn',{attrs:{"color":"error","loading":_vm.loading},on:{"click":_vm.deleteData}},[_vm._v("Delete")]):_vm._e()],1):_vm._e()],1),_vm._v(" "),(_vm.images.length < 1)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77847ac6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(54);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77847ac6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-card',{staticClass:"pa-5"},[_c('v-text-field',{attrs:{"label":"Email","name":"email","required":""},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Password","required":"","type":"password"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-btn',{attrs:{"large":"","block":"","color":"primary"},on:{"click":_vm.login}},[_vm._v("\n        Login\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23c43240_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__(58);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23c43240_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"270"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[(_vm.showDialog === true)?_c('v-card',[_c('v-toolbar',{attrs:{"dense":""}},[_c('v-toolbar-title',{staticStyle:{"font-family":"'Pacifico', cursive","overflow":"visible","font-size":"0.8em"}},[_vm._v(_vm._s(_vm.activeImage.name)+" "),(_vm.activeImage.cost !== undefined && _vm.activeImage.cost !== '')?_c('span',[_vm._v(" - "+_vm._s(_vm.activeImage.cost))]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.showDialog=false}}},[_c('v-icon',[_vm._v("clear")])],1)],1),_vm._v(" "),_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.activeImage.src}}),_vm._v(" "),_c('v-toolbar',{attrs:{"dense":""}},[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.lastImage}},[_c('v-icon',[_vm._v("keyboard_arrow_left")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.nextImage}},[_c('v-icon',[_vm._v("keyboard_arrow_right")])],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[19]);


// WEBPACK FOOTER //
// static/js/app.1a7a9a45e447c7ffd7c3.js